import React, { useRef, useState } from 'react'
import Banner from './Banner';
import { ReactComponent as LogoIcon } from '../../assets/plus_icon/Logo.svg'
// import { ReactComponent as RightIcon } from '../../../assets/plus_icon/right_white.svg';
import AppleIcon from '../../assets/plus_icon/apple.png';
import GoogleIcon from '../../assets/plus_icon/google.png';
import Qr_backImage from '../../assets/plus_icon/qr_back.jpg'
import MobileQRIcon from '../../assets/plus_icon/mobile_qr.png'
// import { Modal } from 'react-bootstrap';
import AndroidImg from '../../assets/plus_icon/android.jpeg';
import IosImg from '../../assets/plus_icon/ios.jpeg'

const AppQRCode = ({ setChannelPartner, coverImage, projectName }) => {
    const [isAndroid, setIsAndroid] = useState(false);

    return (
        <div className=' mx-auto overflow-auto '>
            <div className='!w-full'>
                <Banner coverImage={coverImage} projectName={projectName} />
            </div>
            <div className='!w-full flex items-center flex-col justify-center !my-6 bg-white rounded-xl'>
                <div className='!w-full !p-6'>
                    <div className=''>
                        <div className=' !p-3 rounded-xl border text-xl font-medium text-center flex items-center'>
                            <span className='!mr-3'><LogoIcon /></span>
                            Download Propacity Plus app.
                        </div>
                    </div>
                    <div className='w-full h-[378px] !mt-10 flex flex-col mx-auto justify-center items-center' style={{ background: `url(${Qr_backImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <div className='flex items-center justify-center w-full'>
                            {!isAndroid && <div className='flex flex-col items-center justify-center'>
                                <div className='h-[164px] w-[164px] border rounded-lg'>
                                    <img src={IosImg} alt="" />
                                </div>
                                <button className='!mt-6'>
                                    <img src={AppleIcon} />
                                </button>
                            </div>}
                            {isAndroid && <div className='flex flex-col items-center justify-center'>
                                <div className='h-[164px] w-[164px] border rounded-lg'>
                                    <img src={AndroidImg} alt="" />
                                </div>
                                <button className='!mt-6'>
                                    <img src={GoogleIcon} />
                                </button>
                            </div>}
                        </div>
                        <div className='flex !mt-4 sm:!mt-6' >
                            <button
                                className={`${isAndroid ? 'bg-primary text-white' : 'text-[#314155 bg-white'} rounded-l-lg text-base sm:text-xl !py-2 !px-4 sm:!px-6`}
                                onClick={() => setIsAndroid(true)}
                            >Google Android </button>
                            <button
                                className={`${!isAndroid ? 'bg-primary text-white' : 'text-[#314155 bg-white'} rounded-r-lg text-base sm:text-xl !py-2 !px-4 sm:!px-6`}
                                onClick={() => setIsAndroid(false)}
                            >Apple IOS </button>
                        </div>
                    </div>
                    <div className='w-full mx-auto sm:w-1/2'>

                        <button className='w-full sm:h-[80px] !mt-20 text-lg sm:!text-2xl font-semibold rounded-xl py-2 sm:!py-3.5 bg-blue-900 text-white' onClick={() => {
                            setChannelPartner('7')
                        }}>Done</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppQRCode